import { useEffect } from 'react';
import styled from 'styled-components';
import { LoginBanner } from './banner';
import { Button } from 'modules/components/common';
import { digitsEnToFa } from 'persian-tools2';

export const Support = ({ setShowCrm }) => {
  const handlePopstate = (event) => {
    event.preventDefault();
    setShowCrm(false);
  };

  useEffect(() => {
    window.history.pushState(null, null, window.location.href);
    window.addEventListener('popstate', handlePopstate);
    return () => {
      window.removeEventListener('popstate', handlePopstate);
    };
  }, []);

  return (
    <StyledWrapper>
      <div className="support-container">
        <div className="support-banner">
          <LoginBanner />
        </div>
        <p className="call-support">تماس با پشتیبانی</p>
        <p className="description">
          در صورت وجود هرگونه مشکل در
          <br /> ورود یا ثبت نام؛ با کارشناسان واحد آموزش و ارتباط شرکت فریر آسا
          طب تماس بگیرید:
        </p>
        <a href={`tel:02124837114`} target="_system" data-rel="external">
          <div className="phone" dir='ltr'>{digitsEnToFa(' 021-24837114 ')}</div>
        </a>
        <Button
          text="بازگشت"
          className="back-login"
          actionHandler={() => setShowCrm(false)}
        />
      </div>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .support-btn {
    color: #4e4e4e;
    border-radius: 28px;
    border: 1px solid #ffffff;
    padding: 11px 12px 11px 26px;
    background: #f5f5f5;
    box-shadow: -4px -4px 15px 0px #ffffff, 4px 4px 15px 0px #acacac80;
    margin-bottom: 25px;
  }
  .support-container {
    width: 100%;
    display: grid;
    place-items: center;
  }
  .support-banner {
    display: none;
  }
  .call-support {
    display: none;
    margin-top: 40px;
    color: #753cbe;
    font-size: 18px;
    line-height: 28px;
    font-family: 'dana-bold';
  }
  .description {
    margin: 52px 28px 41px;
    font-size: 17.5px;
    line-height: 32px;
    text-align: center;
    color: #707070;
  }
  .back-login {
    width: 200px;
    padding: 10px 0;
    border-radius: 16px;
    box-shadow: -4px -4px 15px 0 #ffffff,
      4px 4px 15px 0 rgba(172, 172, 172, 0.5);
    border: solid 1px #ffffff;
    background-color: #f5f5f5;
    font-size: 18px;
    color: #753cbe;
  }
  @media screen and (min-width: 1024px) {
    .call-support {
      display: block;
    }
    .phone {
      direction: ltr;
      font-size: 24px;
      font-family: 'dana-bold';
      text-align: center;
      color: #753cbe;
      margin-bottom: 48px;
    }
    .description {
      margin: 14px auto 24px;
    }
    .support-container {
      text-align: center;
      padding: 50px 40px 56px;
      width: 420px;
      border-radius: 16px;
      background: #f5f5f5;
      height: min-content;
    }
    .support-banner {
      display: block;
    }
    .support-btn {
      display: none;
    }
  }
  @media screen and (max-width: 1024px) {
    .phone {
      direction: ltr;
      width: 207px;
      padding: 8px 12px;
      border-radius: 100px;
      box-shadow: -4px -4px 15px 0 #ffffff,
        4px 4px 15px 0 rgba(172, 172, 172, 0.5);
      border: solid 1px #ffffff;
      background-color: #f5f5f5;
      font-size: 21px;
      font-weight: bold;
      text-align: center;
      color: #707070;
      margin-bottom: 53px;
    }
  }
`;
